import { createContext } from 'react';
import type { ReactNode } from 'react';

export interface ConfirmOptions {
  title?: string;
  description?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  /** "error" for destructive actions, "primary" otherwise. */
  tone?: 'error' | 'primary';
}

export type ConfirmFn = (options?: ConfirmOptions) => Promise<boolean>;

export const ConfirmContext = createContext<ConfirmFn | undefined>(undefined);
